import { AccountDto } from '@api/core';
import { isDefined } from '@stillmandigital/common';

export function getAccountIdFromUrl(url: string): number | undefined {
  const accountId = url.startsWith('/accounts/details') ? url.split('/')[3] : undefined;

  return isDefined(accountId) ? Number(accountId) : undefined;
}

export const DEFAULT_VISIBLE_ACCOUNT_TYPES: AccountDto.AccountTypeEnum[] = [
  AccountDto.AccountTypeEnum.Company,
  AccountDto.AccountTypeEnum.Individual,
  AccountDto.AccountTypeEnum.LiquidityReceiver,
];

export function groupSubAccounts<T extends AccountDto>(accounts: T[]): T[] {
  const ids = new Set(accounts.map(account => account.id));
  const isNested = (account: T) => isDefined(account.parentAccountId) && ids.has(account.parentAccountId);
  const result: T[] = [];
  for (const account of accounts) {
    if (isNested(account)) {
      continue;
    }
    result.push(account, ...accounts.filter(sub => isNested(sub) && sub.parentAccountId === account.id));
  }
  return result;
}
